const signin = {
  EN: {
    title: 'LOG IN',
    placeholder_username: 'Email',
    placeholder_username_Phone: 'Phone Number',
    placeholder_password: 'Password',
    login_button: 'Log in',
    remember: 'Remember me',
    forgot_password: 'Forgot password?',
    or: 'OR',
    log_button_Google: 'Log in with Google',
    log_button_Facebook: 'Log in with Facebook',
    not_have_account: "Don't have an account yet?",
    create_login: 'Create a new account',
    invalid_account: 'Invalid email or password, please try again',
    username_empty: 'Please enter your email',
    password_empty: 'Please enter your password',
    both_empty: 'Please enter your email and password',
  },
  TH: {
    title: 'เข้าสู่ระบบ',
    placeholder_username: 'อีเมล',
    placeholder_username_Phone: 'หมายเลขโทรศัพท์',
    placeholder_password: 'รหัสผ่าน',
    login_button: 'เข้าสู่ระบบ',
    remember: 'จำข้อมูลการเข้าสู่ระบบ',
    forgot_password: 'ลืมรหัสผ่าน?',
    or: 'หรือ',
    log_button_Google: 'เข้าสู่ระบบด้วย Google',
    log_button_Facebook: 'เข้าสู่ระบบด้วย Facebook',
    not_have_account: 'ยังไม่มีบัญชีผู้ใช้?',
    create_login: 'สร้างบัญชีใหม่',
    invalid_account: 'อีเมลหรือรหัสผ่านไม่ถูกต้อง กรุณาลองอีกครั้ง',
    username_empty: 'กรุณากรอกอีเมล',
    password_empty: 'กรุณากรอกรหัสผ่าน',
    both_empty: 'กรุณากรอกอีเมลและรหัสผ่าน',
  },
};

export default signin;
